/**
 * SERP passkey / WebAuthn helpers — thin wrapper around @simplewebauthn/browser
 * that fits SERP's axios `api` client and JWT-cookie session.
 */
import { startRegistration, startAuthentication, browserSupportsWebAuthn } from "@simplewebauthn/browser";
import api from "@/lib/api";

export const isPasskeySupported = () => {
  try { return browserSupportsWebAuthn(); } catch { return false; }
};

/** Ask backend if a given username/email already has ≥1 passkey. */
export async function checkPasskeyAvailable(ident) {
  if (!ident) return false;
  try {
    const { data } = await api.get(`/auth/passkey/available/${encodeURIComponent(ident)}`);
    return !!data?.available;
  } catch { return false; }
}

/** Register a new passkey for the currently-authenticated user. */
export async function registerPasskey({ label } = {}) {
  const { data: options } = await api.post("/auth/passkey/register/options");
  const attResp = await startRegistration({ optionsJSON: options });
  if (label) attResp.label = label;
  const { data } = await api.post("/auth/passkey/register/verify", { credential: attResp });
  return data;
}

/** Sign in with a passkey. Returns the same shape as POST /auth/login. */
export async function loginWithPasskey(username) {
  const { data: options } = await api.post("/auth/passkey/login/options", { username });
  const asseResp = await startAuthentication({ optionsJSON: options });
  const { data } = await api.post("/auth/passkey/login/verify", {
    username, credential: asseResp,
  });
  return data;
}

export async function listPasskeys() {
  const { data } = await api.get("/auth/passkey/list");
  return data?.passkeys || [];
}

export async function deletePasskey(id) {
  await api.delete(`/auth/passkey/${id}`);
}
